import { render, staticRenderFns } from "./PortIssueBody.vue?vue&type=template&id=045ab6c6&scoped=true"
import script from "./PortIssueBody.vue?vue&type=script&lang=js"
export * from "./PortIssueBody.vue?vue&type=script&lang=js"
import style0 from "./PortIssueBody.vue?vue&type=style&index=0&id=045ab6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ab6c6",
  null
  
)

export default component.exports